import { useState } from 'react';

import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { prepareFilter } from 'libs/common';
import { CallsGrid } from './grid';
import Filter from './filter';

// const sortInitial = [{ field_name: 'timestamp', direction: 'desc' }];
const sortInitial = [{ field_name: 'calldate', direction: 'desc' }];
const itemsInitial = {};

export const Calls = (props) => {
  const [items, setItems] = useState(itemsInitial);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('calls', sortInitial);

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    //console.log('🚀 ~ prepareParams ~ data:', data);
    const durationFields = ['dur_from', 'dur_to'];
    const addParams = {};
    return prepareFilter(data, addParams, { durationFields });
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    updateEntry: (id, data) => {
      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    clearEntries: () => setItems({}),
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return <Controller {...props} {...gridParams} {...gridActions} type="calls" filterName="callsFilter" grid={CallsGrid} gridFilter={Filter} getRequestParams={prepareParams} />;
};
